import React from "react";
import Header from "./Header";
import Footer from "./Footer";

function Ask() {
    return (
        <div className="Ask-container">
            <Header />
            <div className="Ask-ask-container">
                <div className="Ask-send-element">
                    <p>받는 사람</p>
                </div>
                <div className="Ask-send-email">
                    <p>ddd</p>
                </div>
            </div>
            <div className="Ask-ask-container">
                <div className="Ask-send-element">
                    <p>제목</p>
                </div>
                <div className="Ask-send-title">

                </div>
            </div>
            <div className="Ask-ask-container">
                <div className="Ask-send-element">
                    <p>내용</p>
                </div>
                <div className="Ask-send-detail">

                </div>
            </div>
        </div>

    );
}

export default Ask;
